/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-08-15 15:03:13
 * @LastEditors: wl
 * @LastEditTime: 2020-08-15 15:09:49
 */
import axios from '../axios'

// 楼栋配置列表
export const findPage = (data) => {
    return axios({
        url: '/admin/service/sys_brake_list',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/brake.js